import { useParams } from "react-router";
import { FeedUserProfileBase } from "views/knowledge/feed/FeedUserProfile/FeedUserProfileBase";

export interface IOpenForm {
    userId: string | undefined;
    name: string | undefined;
}

/**
 * Feed do Perfil do UsuÃ¡rio.
 * @param props
 */
export const FeedUserProfile: React.FC<{ isHome?: boolean, isKnowledge?: boolean; }> = ({ isHome = false, isKnowledge = false }) => {
    const { id: userId } = useParams();

    ////////////////////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////////////////////

    return (
        <FeedUserProfileBase userId={userId!} isHome={isHome} isKnowledge={isKnowledge} breakpoint="lg" />
    );
};
